/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R4_LabelInputs */

const tr_iletisim_s7_r4_label = /** @type {(inputs: Iletisim_S7_R4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS ve BTK`)
};

const en_iletisim_s7_r4_label = /** @type {(inputs: Iletisim_S7_R4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS and BTK`)
};

const de_iletisim_s7_r4_label = /** @type {(inputs: Iletisim_S7_R4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS und BTK`)
};

const ru_iletisim_s7_r4_label = /** @type {(inputs: Iletisim_S7_R4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS и BTK`)
};

/**
* | output |
* | --- |
* | "ETBİS and BTK" |
*
* @param {Iletisim_S7_R4_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r4_label = /** @type {((inputs?: Iletisim_S7_R4_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R4_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r4_label(inputs)
	if (locale === "de") return de_iletisim_s7_r4_label(inputs)
	if (locale === "ru") return ru_iletisim_s7_r4_label(inputs)
	return tr_iletisim_s7_r4_label(inputs)
});